class rMoreItems extends HTMLElement {
    constructor() {
        super()

        this.isExpanded = false

        this.handleTrigger = this.handleTrigger.bind(this)
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.moreText = this.dataset.moreText
            this.lessText = this.dataset.lessText

            this.trigger = this.querySelector('[r-more-items-trigger]')
            this.triggerText = this.querySelector('[r-more-items-trigger-text]')
            this.target = this.querySelector('[r-more-items-target]')

            if (this.hasAttribute('r-more-items-self-target')) {
                this.target = this
            }

            if (this.trigger && this.target) {
                this.trigger.addEventListener('click', this.handleTrigger)
            }
        })
    }

    handleTrigger() {
        this.isExpanded = !this.isExpanded

        this.trigger.classList.toggle('is-expanded', this.isExpanded)
        this.target.classList.toggle('is-expanded', this.isExpanded)

        if (this.triggerText) {
            this.triggerText.innerHTML = ( this.isExpanded ? this.lessText : this.moreText )
        }
    }
}

customElements.define('r-more-items', rMoreItems)

export default rMoreItems;